import { Link } from "react-router-dom";
import { LanguageToggle } from "@/components/LanguageToggle";
import { ThemeToggle } from "@/components/ThemeToggle";

export function MarketingFooter() {
  return (
    <footer className="bg-card border-t border-border py-14">
      <div className="container mx-auto px-4 grid md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <img src="/conorbit-logo.png" alt="CONORBIT" className="h-12 mb-4" />
          <p className="text-justify text-xs text-muted-foreground leading-relaxed max-w-xs">
            The communications backbone built for institutional press operations.
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-wider text-foreground font-semibold mb-3">Product</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/platform" className="hover:text-foreground">Platform</Link></li>
            <li><Link to="/social-suite" className="hover:text-foreground">Social Suite</Link></li>
            <li><Link to="/coverage" className="hover:text-foreground">Coverage</Link></li>
            <li><Link to="/journalists" className="hover:text-foreground">For Journalists</Link></li>
            <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
            <li><Link to="/faq" className="hover:text-foreground">FAQ</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-wider text-foreground font-semibold mb-3">Company</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/auth" className="hover:text-foreground">Institution login</Link></li>
            <li><Link to="/portal/login" className="hover:text-foreground">Journalist portal</Link></li>
            <li><Link to="/privacy" className="hover:text-foreground">Privacy</Link></li>
            <li><Link to="/terms" className="hover:text-foreground">Terms</Link></li>
            <li><Link to="/support" className="hover:text-foreground">Support</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-wider text-foreground font-semibold mb-3">Preferences</h4>
          <div className="flex gap-2 items-center">
            <LanguageToggle />
            <ThemeToggle />
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mt-10 pt-6 border-t border-border text-xs text-muted-foreground flex flex-wrap justify-between gap-2">
        <span>© {new Date().getFullYear()} CONORBIT. All rights reserved.</span>
        <span>Built for institutions that take press seriously.</span>
      </div>
    </footer>
  );
}
